import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Zap } from 'lucide-react';

const BoldHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { href: '#home', label: 'HOME' },
    { href: '#app', label: 'APP' },
    { href: '#why', label: 'WHY IT WORKS' },
    { href: '#stories', label: 'STORIES' },
    { href: '#pricing', label: 'PRICING' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-black/90 backdrop-blur-md border-b border-electric-blue/20 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Bold Logo */}
          <div className="flex items-center group">
            <div className="relative">
              <div className="w-12 h-12 bg-gradient-primary rounded-xl flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                <Zap className="w-8 h-8 text-white" />
              </div>
              {/* Logo Glow */}
              <div className="absolute inset-0 bg-gradient-primary rounded-xl blur-lg opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
            </div>
            <span className="text-2xl font-black text-white uppercase tracking-wide">
              COACH<span className="text-neon-green">AI</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="relative text-white font-semibold text-sm uppercase tracking-wide hover:text-neon-green transition-colors duration-200 group"
              >
                {item.label}
                <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-gradient-primary group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
          </nav>

          {/* CTA Buttons - Desktop */}
          <div className="hidden md:flex items-center space-x-4">
            <button 
              onClick={() => navigate('/login')}
              className="text-white hover:text-neon-green transition-colors duration-200 font-semibold uppercase tracking-wide"
            >
              SIGN IN
            </button>
            <button 
              onClick={() => navigate('/register')}
              className="btn-power px-6 py-3"
            >
              START FREE
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-white hover:text-neon-green transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-electric-blue/20">
            <nav className="py-6 space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="block py-3 text-white hover:text-neon-green transition-colors font-semibold uppercase tracking-wide"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <div className="pt-6 space-y-4">
                <button 
                  onClick={() => navigate('/login')}
                  className="block w-full py-3 text-white hover:text-neon-green transition-colors font-semibold uppercase tracking-wide text-left"
                >
                  SIGN IN
                </button>
                <button 
                  onClick={() => navigate('/register')}
                  className="w-full btn-power py-3"
                >
                  START FREE
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default BoldHeader;